import React from 'react';
import { useOnboardingProgress } from '../../hooks/onboarding';
import { ONBOARDING_STEPS } from '../../types/onboarding';
import {
  ProgressContainer,
  ProgressBar,
  ProgressFill,
  ProgressInfo,
  StepIndicator,
  StepDot
} from '../../styles/onboarding/OnboardingProgress.styles';

export const OnboardingProgress: React.FC = () => {
  const progress = useOnboardingProgress();

  return (
    <ProgressContainer>
      <ProgressBar>
        <ProgressFill $percentage={progress.percentage} />
      </ProgressBar>
      <ProgressInfo>
        <span>Step {progress.currentStepIndex} of {progress.totalSteps}</span>
        {/* Same weighted score the Matches feed reports, so the two surfaces
            never show different completion figures. */}
        <span>{progress.percentage}% Complete</span>
      </ProgressInfo>
      <StepIndicator>
        {ONBOARDING_STEPS.map((step) => (
          <StepDot
            key={step.id}
            $isActive={progress.stepStatuses[step.id]?.isCurrent || false}
            $isComplete={progress.stepStatuses[step.id]?.isComplete || false}
            $isSkipped={progress.stepStatuses[step.id]?.isSkipped || false}
            title={step.title}
          />
        ))}
      </StepIndicator>
    </ProgressContainer>
  );
};

